
import React from 'react';
import './App.scss';
import "bootstrap-icons/font/bootstrap-icons.css";
import 'bootstrap/dist/css/bootstrap.css';

import { Route, Switch } from "react-router-dom";
import DrawerRouterContainer from './components/DrawerRouterContainer';
import Home from './pages/Home';
import Login from "./pages/Login";

//IMPORTS PAGES FARMS//
import FarmList from "./pages/FarmsPages/FarmList";
import CreateFarm from "./pages/FarmsPages/CreateFarm";
import FarmDetails from "./pages/FarmsPages/FarmDetails";
import FarmGeneralInformation from "./pages/FarmsPages/FarmGeneralInformation";
import FarmLocations from "./pages/FarmsPages/FarmLocations";
import FarmStoragePoints from "./pages/FarmsPages/FarmStoragePoints";
import FarmGroups from "./pages/FarmsPages/FarmGroups";
import FarmContacts from "./pages/FarmsPages/FarmContacts";
import FarmOrders from "./pages/FarmsPages/FarmOrders";
import FarmMovements from "./pages/FarmsPages/FarmMovements";
import FarmMovementDetails from "./pages/FarmsPages/FarmMovementDetails";
import FarmFeedReceipts from "./pages/FarmsPages/FarmFeedReceipts";
import FarmTasks from "./pages/FarmsPages/FarmTasks";

//IMPORTS PAGES NAVE//
import ListNaves from './pages/NavesPages/ListNaves';
import CreateNaves from './pages/NavesPages/CreateNaves';
import DetailsNaves from './pages/NavesPages/DetailsNaves';
import InformationNaves from './pages/NavesPages/InformationNaves';
import SilosNaves from './pages/NavesPages/SilosNaves';
import AlternationNaves from './pages/NavesPages/AlternationNaves';

//IMPORTS PAGES SILOS//
import ListSilos from './pages/SilosPages/ListSilos';
import CreateSilos from './pages/SilosPages/CreateSilos';
import DetailsSilos from './pages/SilosPages/DetailsSilos';
import InformationSilos from './pages/SilosPages/InformationSilos';
import FoodReceiptsSilos from './pages/SilosPages/FoodReceiptsSilos';
import NavesSilos from './pages/SilosPages/NavesSilos';
//IMPORTS PAGES GRUPOS GRANJAS//
import ListGroupFarms from "./pages/GroupFarmsPages/ListGroupFarms";
import DetailsGroupFarms from "./pages/GroupFarmsPages/DetailsGroupFarms";
import CreateGroupFarms from "./pages/GroupFarmsPages/CreateGroupFarms";
import InformationGroupFarms from "./pages/GroupFarmsPages/InformationGroupFarms";
import MovementsGroupFarms from "./pages/GroupFarmsPages/MovementsGroupFarms";
import CreateMovementsGroupFarms from "./pages/GroupFarmsPages/CreateMovementsGroupFarms";
import DetailsMovementsGroupFarms from "./pages/GroupFarmsPages/DetailsMovementsGroupFarms";
import GroupSequencesGroupFarms from "./pages/GroupFarmsPages/GroupSequencesGroupFarms";
import PowerCurveGroupFarms from "./pages/GroupFarmsPages/PowerCurveGroupFarms";
//IMPORTS PAGES CONTACTOS//
import ListContacts from "./pages/ContactsPages/ListContacts";
import CreateContacts from "./pages/ContactsPages/CreateContacts";
import DetailsContacts from "./pages/ContactsPages/DetailsContacts";
//IMPORTS PAGES Orders//
import ListOrders from "./pages/OrdersPages/ListOrders";
import DetailsOrders from "./pages/OrdersPages/DetailsOrders";
import CreateOrders from "./pages/OrdersPages/CreateOrders";
//IMPORTS PAGES MOVEMENTS//
import ListMovements from "./pages/MovementsPages/ListMovements";
import DetailsMovements from "./pages/MovementsPages/DetailsMovements";
//IMPORTS PAGES FARM FEED RECEIPTS//
import ListFarmFeedReceipts from "./pages/FarmFeedReceiptsPages/ListFarmFeedReceipts";
//IMPORTS PAGES GROUPS//
import ListGroups from "./pages/GroupsPages/ListGroups";
//IMPORTS PAGES FOOD RECEIPTS//
import ListFoodReceipts from "./pages/FoodReceiptsPages/ListFoodReceipts";
//IMPORTS PAGES TASKS//
import ListTasks from "./pages/TasksPages/ListTasks";
import CreateTasks from "./pages/TasksPages/CreateTasks";
import DetailsTasks from "./pages/TasksPages/DetailsTasks";
//IMPORTS PAGES ANIMAL MOVEMENTS//
import ListAnimalMovements from "./pages/AnimalMovementsPages/ListAnimalMovements";
import DetailsAnimalMovements from "./pages/AnimalMovementsPages/DetailsAnimalMovements";
import OrdersOrderNavigation from "./pages/OrderNavigationPages/OrdersOrderNavigation";

//IMPORTS ORDERS//
import InformationOrderNavigations from "./pages/OrderNavigationPages/InformationOrderNavigations";
import OrderForecastOrderNavigation from "./pages/OrderNavigationPages/OrderForecastOrderNavigation";


import version from './version'

function App() {
  return (
    <div>
      <DrawerRouterContainer>
        <Switch>
          <Route exact path={["/", "/home"]} component={Home} />
          <Route exact path="/login" component={Login} />

          <Route exact path="/Farms/" component={FarmList} />
          <Route exact path="/Farms/Create" component={CreateFarm} />
          <Route exact path="/Farms/:farmId/" component={FarmDetails} />
          <Route exact path="/Farms/:farmId/Details" component={FarmDetails} />
          <Route exact path="/Farms/:farmId/GeneralInformation" component={FarmGeneralInformation} />
          <Route exact path="/Farms/:farmId/Locations" component={FarmLocations} />
          <Route exact path="/Farms/:farmId/StoragePoints" component={FarmStoragePoints} />
          <Route exact path="/Farms/:farmId/Groups" component={FarmGroups} />
          <Route exact path="/Farms/:farmId/Contacts" component={FarmContacts} />
          <Route exact path="/Farms/:farmId/Orders" component={FarmOrders} />
          <Route exact path="/Farms/:farmId/Movements" component={FarmMovements} />
          <Route exact path="/Farms/:farmId/Movements/:movementId/" component={FarmMovementDetails} />
          <Route exact path="/Farms/:farmId/Movements/:movementId/Details" component={FarmMovementDetails} />
          <Route exact path="/Farms/:farmId/FeedReceipts" component={FarmFeedReceipts} />
          <Route exact path="/Farms/:farmId/Tasks" component={FarmTasks} />
          
          <Route exact path="/Naves/" component={ListNaves} />
          <Route exact path="/CreateNaves/" component={CreateNaves} />
          <Route exact path="/DetailsNaves/" component={DetailsNaves} />
          <Route exact path="/InformationNaves/" component={InformationNaves} />
          <Route exact path="/SilosNaves/" component={SilosNaves} />
          <Route exact path="/AlternationNaves/" component={AlternationNaves} />
          
          <Route exact path="/Silos/" component={ListSilos} />
          <Route exact path="/CreateSilos/" component={CreateSilos} />
          <Route exact path="/DetailsSilos/" component={DetailsSilos} />
          <Route exact path="/InformationSilos/" component={InformationSilos} />
          <Route exact path="/FoodReceiptsSilos/" component={FoodReceiptsSilos} />
          <Route exact path="/NavesSilos/" component={NavesSilos} />

          <Route exact path="/GroupFarms/" component={ListGroupFarms} />
          <Route exact path="/CreateGroupFarms/" component={CreateGroupFarms} />
          <Route exact path="/DetailsGroupFarms/" component={DetailsGroupFarms} />
          <Route exact path="/InformationGroupFarms/" component={InformationGroupFarms} />
          <Route exact path="/MovementsGroupFarms/" component={MovementsGroupFarms} />
          <Route exact path="/CreateMovementsGroupFarms/" component={CreateMovementsGroupFarms} />
          <Route exact path="/DetailsMovementsGroupFarms/" component={DetailsMovementsGroupFarms} />
          <Route exact path="/GroupSequencesGroupFarms/" component={GroupSequencesGroupFarms} />
          <Route exact path="/PowerCurveGroupFarms/" component={PowerCurveGroupFarms} />
          
          <Route exact path="/Contacts/" component={ListContacts} />
          <Route exact path="/CreateContacts/" component={CreateContacts} />
          <Route exact path="/DetailsContacts/" component={DetailsContacts} />
          
          <Route exact path="/Orders/" component={ListOrders} />
          <Route exact path="/DetailsOrders/" component={DetailsOrders} />
          <Route exact path="/CreateOrders/" component={CreateOrders} />

          <Route exact path="/Movements/" component={ListMovements} />
          <Route exact path="/DetailsMovements/" component={DetailsMovements} />
          
          <Route exact path="/FarmFeedReceipts/" component={ListFarmFeedReceipts} />

          <Route exact path="/Tasks/" component={ListTasks} />  
          <Route exact path="/CreateTasks/" component={CreateTasks} />
          <Route exact path="/DetailsTasks/" component={DetailsTasks} />

          <Route exact path="/Groups/" component={ListGroups} />

          <Route exact path="/AnimalMovements/" component={ListAnimalMovements} />
          <Route exact path="/DetailsAnimalMovements/" component={DetailsAnimalMovements} />

          <Route exact path="/FoodReceipts/" component={ListFoodReceipts} />

          <Route exact path="/InformationOrderNavigations/" component={InformationOrderNavigations} />
          <Route exact path="/OrderForecastOrderNavigation/" component={OrderForecastOrderNavigation} />
          <Route exact path="/OrdersOrderNavigation/" component={OrdersOrderNavigation} />
          {/* Add more routes as needed */}

        </Switch>
        <div>
          <hr style={{ width: '100%' }} />
          <footer>FeedPlanner  {version}  © {(new Date().getFullYear())} Agrifood Alternative Technologies, SL & Caedis Integral Solutions, SL </footer>
        </div>

      </DrawerRouterContainer>
    </div>
  );
}

export default App;
